import { render, staticRenderFns } from "./FinalizacaoDesassociarEntrega.vue?vue&type=template&id=0a7db1a8"
import script from "./FinalizacaoDesassociarEntrega.vue?vue&type=script&lang=js"
export * from "./FinalizacaoDesassociarEntrega.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports